module.exports = __webpack_public_path__ + "static/img/banner.e59bc75.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/active_26423/images/banner.png
// module id = JeiC
// module chunks = 39